import { currentPeriodUtc } from '../lib/period';

/** One place that knows every cache key, so invalidation cannot drift from subscription. */
export const qk = {
  me: () => ['me'] as const,
  keys: {
    all: () => ['keys'] as const,
    list: () => ['keys', 'list'] as const,
    detail: (keyId: string) => ['keys', 'detail', keyId] as const,
  },
  apiTokens: {
    all: () => ['api-tokens'] as const,
    list: () => ['api-tokens', 'list'] as const,
  },
  /** A mutation's key, not a query's: the Issue dialog asks whether a token is on its way. */
  issueApiToken: () => ['issue-api-token'] as const,
  /** The tenant's containers, the default first. Every page about a container's contents
   *  reads this to know the container exists. */
  containers: () => ['containers'] as const,
  /** Every container's firewalls; a page filters by `container_id`. */
  firewalls: () => ['firewalls'] as const,
  /** One container's permission chain head. Issuing and restricting an API token write the
   *  head their answer carries straight into it. */
  permissionChain: (containerId: string) => ['permission-chain', containerId] as const,
  usage: (period: string) => ['usage', period] as const,
  /** Standing and this month's estimate. `null` in the cache means billing is not enabled
   *  on this API, which is an answer, not an error. */
  billing: () => ['billing'] as const,
  audit: {
    all: () => ['audit'] as const,
    feed: (keyId: string, since: string | null, limit: number) =>
      ['audit', 'feed', keyId, since, limit] as const,
    /** The quickstart's first-encrypt watch. Separate from the feed so polling one does
     *  not churn the other's cache. */
    live: (keyId: string) => ['audit', 'live', keyId] as const,
    /** The Overview activity strip: a short, shared read of one key's newest events.
     *  Distinct from `live` so the quickstart's three-second poll cannot invalidate it. */
    recent: (keyId: string, limit: number) => ['audit', 'recent', keyId, limit] as const,
  },
} as const;

export { currentPeriodUtc };
